export type LoginType = 'cloud' | 'onPrem';

export const LoginType = {
  Cloud: 'cloud',
  OnPrem: 'onPrem',
} as const;
